<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 26 26"
    height="24"
    width="24"
  >
    <g transform="translate(1, 1)">
      <g
        fill-rule="evenodd"
        fill="none"
        stroke-width="1"
        stroke="none"
        id="icon/misc/add"
      >
        <path
          :fill="color"
          id="Combined-Shape"
          d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M12,5.84318325 C12.2761424,5.84318325 12.5,6.06704088 12.5,6.34318325 L12.5,6.34318325 L12.5,11.5 L17.6568542,11.5000375 C17.9329966,11.5000375 18.1568542,11.7238951 18.1568542,12.0000375 C18.1568542,12.2761799 17.9329966,12.5000375 17.6568542,12.5000375 L12.5,12.5 L12.5,17.6568918 C12.5,17.9023516 12.3231248,18.1065001 12.0898756,18.1488361 L12,18.1568918 C11.7238576,18.1568918 11.5,17.9330341 11.5,17.6568918 L11.5,17.6568918 L11.5,12.5 L6.34314575,12.5000375 C6.06700338,12.5000375 5.84314575,12.2761799 5.84314575,12.0000375 C5.84314575,11.7238951 6.06700338,11.5000375 6.34314575,11.5000375 L11.5,11.5 L11.5,6.34318325 C11.5,6.09772336 11.6768752,5.89357488 11.9101244,5.85123892 Z"
          vector-effect="non-scaling-stroke"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
    name: 'AddIcon',
    props: {
        color: {
            type: String,
            default() {
                return '#256AB3';
            },
        },
    },
}
</script>